/**
 * 活动详情
 **/

import React from 'react';
import {connect} from "react-redux";
import {Table, Timeline, Popover, message, Row, Spin} from 'antd';
import {findEventWithViewedCounted} from "../../services/evt";
import moment from 'moment';
import Iconfont from "../../components/Iconfont/Iconfont";
import QRCode from "../../components/qr-code/QRCode";
import '@/style/events.less';
import logo from "../../style/imgs/logo_text.png";
import {mobile_url_domin} from "../../utils/config";


class Event extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            visible:false,
            event:{
                isFetching:true,
                data:null,
            },

        }
    }

    componentDidMount() {
        this.fetchEvent()

    }

    fetchEvent =()=>{
        findEventWithViewedCounted({id:this.props.params.id}).then(res => {
            if (res.code == 200) {
                this.setState({
                    event:{
                        isFetching:false,
                        data:res.data,
                    }
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        }).finally(() => {
        })
    }

    render() {
        const {event}=this.state;
        return (
            event.data &&
            <div>
                <div className="event-nav">
                    <ul>
                        {!event.data.header.promoteLogo &&
                        <li>
                            <a href="https://www.kancloud.cn/seven_qdj/qdj_help_201808/737970" target='_Blank'>
                                <img src={logo} alt="签到家"/>
                            </a>
                        </li>}
                        <li>
                            <a href="#">首页</a>
                        </li>
                        {event.data.agenda.length > 0 &&
                        <li>
                            <a href="#1">流程</a>
                        </li>}
                        {event.data.guests.length > 0 &&
                        <li>
                            <a href="#2">嘉宾</a>
                        </li>}
                        <li>
                            <a href="#3">详情</a>
                        </li>
                    </ul>
                </div>
                <div className='event-banner'>
                    <div>
                        <div className='event-cover'>
                            <img src={event.data.header.banner ? event.data.header.banner : "https://img.qdj8.cn/admin/default.png"} alt=""/>
                        </div>
                        <div className='event-info'>
                            <div className='event-title'>
                                {event.data.header.name}
                            </div>
                            <div className='event-info-item'>
                                <span>时间：</span>
                                <span>
                                    {moment(event.data.header.beginTime, "YYYY-MM-DD HH:mm:ss").format("YYYY年MM月DD日 HH:mm")}
                                    &nbsp;&nbsp;~&nbsp;&nbsp;{moment(event.data.header.endTime, "YYYY-MM-DD HH:mm:ss").format("YYYY年MM月DD日 HH:mm")}
                                </span>
                            </div>
                            {event.data.header.lng == 0 && event.data.header.lat == 0 ? ''
                                :
                            <div className='event-info-item'>
                                <span>地点：</span>
                                <span>
                                    <a href={`https://uri.amap.com/navigation?to=${event.data.header.lng},${event.data.header.lat},${event.data.header.address}&&mode=car&policy=1&src=mypage&coordinate=gaode&callnative=0`} target='_Blank'>
                                        {event.data.header.address}
                                    </a>
                                </span>
                            </div>}
                            {event.data.header.contactPhone &&
                            <div className='event-info-item'>
                                <span>联系电话：</span>
                                <span>{event.data.header.contactPhone}</span>
                            </div>}
                            {event.data.header.organizers && event.data.header.organizers.length > 0 &&
                            <div className='event-info-item'>
                                <span>主办方：</span>
                                {event.data.header.organizers.map((o,index)=><span key={index}>{o} </span>)}
                            </div>}
                            {event.data.header.contractors && event.data.header.contractors.length !=0 &&
                            <div className='event-info-item'>
                                <span>承办方：</span>
                                {event.data.header.contractors.map((o,index)=><span key={index}>{o} </span>)}
                            </div>}
                            {event.data.header.collaborators && event.data.header.collaborators.length !=0 &&
                            <div className='event-info-item'>
                                <span>协办方：</span>
                                {event.data.header.collaborators.map((o,index)=><span key={index}>{o} </span>)}
                            </div>}
                            {event.data.header.customOrganizer && JSON.parse(event.data.header.customOrganizer).map((obj,index)=>(
                                <div key={index} className='event-info-item'>
                                    <span>{obj.name}：</span>
                                    <span>{obj.value}</span>
                                </div>
                            ))}
                            <div className='event-info-btn'>
                                {event.data.header.freeEvent ?
                                    <a className='register-btn' href={`/mobile/signup/${event.data.header.id}`} target='_Blank'>我要报名</a>
                                    :
                                    <Popover placement="top"
                                         title={'请用手机扫码进行报名'}
                                         content={
                                             <div style={{padding:10,textAlign:'center'}}>
                                                 <QRCode
                                                     value={`${mobile_url_domin}/mobile/signup/${event.data.header.id}?hostUserId=${localStorage.getItem('userId')}`}
                                                     size={120}
                                                     refName="register-qr-canvas"
                                                     logoWidth={25}
                                                     logoHeight={25}
                                                     logo={event.data.header.customQrcodeLogo ? event.data.header.customQrcodeLogo : "https://img.qdj8.cn/logo2.png"}/>
                                             </div>
                                         } trigger="click">
                                    <a className='register-btn'>我要报名</a>
                                </Popover>}

                            </div>

                        </div>
                    </div>

                </div>
                <div className='event-content'>
                    <div>
                        {!event.data.header.freeEvent || event.data.ticketings.length>1 ?
                        <div className='event-ticket'>
                            <div className='event-common-title'>
                                <p>售票</p>
                                <span>TICKETING</span>
                            </div>
                            <div>
                                <Table
                                    columns={
                                        [{
                                            title: '票种名称',
                                            dataIndex: 'name',
                                        }, {
                                            title: '截止时间',
                                            render: (text, record, index)  => <span>{moment(event.data.header.registerEndTime, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD HH:mm")}</span>,
                                        }, {
                                            title: '单价',
                                            render: (text, record, index)  => <span>
                                                {record.price == 0 ? '免费' : <span style={{color:'#FD7926'}}>¥{record.price}</span>}
                                                </span>,
                                        }]
                                    }
                                    dataSource={event.data.ticketings}
                                    pagination={false}
                                    bordered
                                />

                            </div>
                        </div> : '' }
                        {event.data.agenda.length > 0 &&
                        <div className='event-agenda'>
                            <a href="#" name='1'></a>
                            <div className='event-common-title'>
                                <p>流程</p>
                                <span>SCHEDULE</span>
                            </div>
                            <div>
                                <Timeline>
                                    {event.data.agenda.map((obj,index)=>
                                        <Timeline.Item key={index}>
                                            <div style={{fontSize:14}}>
                                                {obj.date}
                                                <span style={{marginLeft:20}}>
                                                    {moment(obj.fromTime, 'HH:mm').format("HH:mm")}&nbsp;&nbsp;至&nbsp;&nbsp;{moment(obj.toTime, 'HH:mm').format("HH:mm")}
                                                </span>
                                                <p style={{marginTop:5}} dangerouslySetInnerHTML={{ __html: obj.content ? obj.content.replace(/\n/g,"<br/>").replace(/\r\n/g,"<br>").replace(/\s/g,"&nbsp;") : '' }}></p>
                                            </div>
                                        </Timeline.Item>
                                    )}

                                </Timeline>
                            </div>

                        </div>}
                        {event.data.guests.length > 0 &&
                        <div className='event-guests'>
                            <a href="#" name='2'></a>
                            <div className='event-common-title'>
                                <p>嘉宾</p>
                                <span>HONORED GUEST</span>
                            </div>
                            <div className='event-guests-content'>
                                {event.data.guests.map((obj,index)=>
                                    <div key={index} className='guests-item'>
                                        <div className='guests-avatar'>
                                            <img src={obj.avatarUrl ? obj.avatarUrl : "https://img.qdj8.cn/admin/guests.png"} alt=""/>
                                        </div>
                                        <div className='guests-info'>
                                            <span>{obj.name}</span>
                                            <p dangerouslySetInnerHTML={{ __html: obj.introduction ? obj.introduction.replace(/\n/g,"<br/>").replace(/\r\n/g,"<br>").replace(/\s/g,"&nbsp;") : '' }}></p>
                                        </div>
                                    </div>
                                )}

                            </div>

                        </div>}
                        <div className='event-summary'>
                            <a href="#" name='3'></a>
                            <div className='event-common-title'>
                                <p>详情</p>
                                <span>DESCRIBE</span>
                            </div>
                            <div>
                            {
                                    event.data.videos.map((obj, index) => (
                                        <a key={index} href={obj.link} style={{
                                            display: 'flex', justifyContent: 'center', alignItems: 'center',width:500,
                                            height: 300, background: `url(${obj.cover}) 0% 0% / 100% 100%`, marginBottom: 30
                                        }}>
                                            <div style={{
                                                width: 50, height: 50,
                                                borderRadius: '50px', background: '#fff',
                                                textAlign: 'center', lineHeight: '50px'
                                            }}>
                                                <Iconfont style={{ fontSize: 20, color: '#000' }} libname="ckicon" type="bofang2" />
                                            </div>
                                        </a>
                                    ))
                                }
                            </div>
                            <div className='event-summary-content' dangerouslySetInnerHTML={{ __html: event.data.header.summary ? event.data.header.summary.replace(/##PageBreak##/g, '').replace(/\n/g,"<br/>").replace(/\r\n/g,"<br>").replace(/\s/g,"&nbsp;") : '' }}></div>
                            <div className='event-posters-content'>
                                {event.data.posters.map((obj,index)=>{
                                    return <div key={index}>
                                        <img  src={obj.url} alt=""/>
                                    </div>
                                })}
                            </div>

                        </div>

                    </div>
                </div>
                {/*<div className='event-footer'>*/}
                    {/*<div>*/}
                        {/*<div className='event-footer-info'>*/}
                            {/*<p>*/}
                                {/*<Iconfont   libname="ckicon" type="dianhua1"/>*/}
                                {/*<span>手机/微信：18615776026</span>*/}
                            {/*</p>*/}
                            {/*<p>*/}
                                {/*<Iconfont   libname="ckicon" type="tubiao215"/>*/}
                                {/*<span>客服QQ：3455994562</span>*/}
                            {/*</p>*/}
                            {/*<p>*/}
                                {/*<Iconfont   libname="ckicon" type="youxiang"/>*/}
                                {/*<span>邮箱：seven@xlzhuoguo.com</span>*/}
                            {/*</p>*/}
                            {/*<p>*/}
                                {/*Copyright © 2014-2018 成都兴隆卓果科技有限公司.All rights reserved.蜀ICP备14015197号*/}
                            {/*</p>*/}
                        {/*</div>*/}
                        {/*<div className='event-footer-qrcode'>*/}
                            {/*<div>*/}
                                {/*<img src="https://img.qdj8.cn/home/gongzonghao.png" alt=""/>*/}
                                {/*<span>签到家公众号</span>*/}
                            {/*</div>*/}
                            {/*<div>*/}
                                {/*<img src="https://img.qdj8.cn/home/APP_xiazai.png" alt=""/>*/}
                                {/*<span>手机APP下载</span>*/}
                            {/*</div>*/}
                        {/*</div>*/}
                    {/*</div>*/}
                {/*</div>*/}
            </div>
        )
    }
}
const mapStateToPorps = state => {
    const evt = state.evt;
    return {evt};
};

export default connect(mapStateToPorps)(Event);


// WEBPACK FOOTER //
// ./src/containers/event/Event.jsx